var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div id="citation-form"></div>\n<div class="citation-output">\n  <h4 class="citation-output-head">Final works-cited-list entry</h4>\n  <p id="citation-el"></p>\n</div>\n<div id="citation-lightbox-placeholder" class="lity-hide"></div>\n';
return __p;
};
